import * as yup from 'yup';

const validators = (__) => () => {
    return yup.object().shape({
        cost: yup.number().required(__(`form.cost.error`)),
        price: yup.number().required(__(`form.price.error`)),

        IdTransportType: yup.number().when('cost', (cost, schema) => {
            if (cost[0] === 1) return schema.required(__(`form.IdTransportType.error`))
        }),

        division: yup.number().when('cost', (cost, schema) => {
            if (cost[0] === 1) return schema.required(__(`form.division.error`))
        }),

        startDistrict: yup.number().when('cost', (cost, schema) => {
            if (cost[0] === 1) return schema.required(__(`form.startDistrict.error`))
        }),

        endDistrict: yup.number().when('cost', (cost, schema) => {
            if (cost[0] === 1) return schema.required(__(`form.endDistrict.error`))
        }),

        RouteType: yup.number().required(__(`form.RouteType.error`)),
    });
};

export default validators
